<template>
  <div class="container" v-if="getUserValues && getPageContent">
    <div class="row">
      <div
        ref="elementToMeasure"
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0"
      >
        <section class="hoorah-section p-4 text-center">
          <NavBar />
          <h1 class="text-white pt-2">
            <strong>{{ getUserValues.name }}</strong>
            <span v-html="getPageContent.name_text"></span>
          </h1>
          <img class="text-center" src="@/assets/hoorah.svg" alt="Speelr" />
          <span
            class="text-white"
            v-html="convertRelativeUrlsToAbsolute(getPageContent.content)"
          ></span>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: "HoorahSection",
  components: {
    NavBar,
  },
  computed: {
    getUserValues() {
      return this.$store.getters.getUserValues;
    },
    getPageContent() {
      return this.$store.getters.getPageContent;
    },
  },
  created() {
    this.$store.commit("setPageType", "hoorah");
    this.$store.dispatch("fetchPageContent");
  },
  methods: {
    gotoQuestions() {
      this.$router.push("/question");
    },
    convertRelativeUrlsToAbsolute(html) {
      let baseUrl = process.env.VUE_APP_ASSETURL;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const images = doc.querySelectorAll("img");

      images.forEach((img) => {
        const src = img.getAttribute("src");
        if (src && !src.startsWith("http")) {
          // Check if the URL is relative
          img.setAttribute("src", `${baseUrl}${src}`);
        }
      });

      return doc.body.innerHTML;
    },
  },
};
</script>

<style>
h1 {
  font-weight: 100;
}
.hoorah-section {
  padding-top: 100px !important;
  border-radius: 0 0 25px 25px;
  background: linear-gradient(
    0deg,
    rgba(244, 162, 225, 1) 0%,
    rgba(255, 174, 103, 1) 70%
  );
}
</style>
